import type { WorkspaceLink, WorkspaceNavigation } from "../studio/WorkContext";

// These coordinates belong to the host, even if a page includes one in its state mapping.
const HOST_COORDINATES = new Set([
  "agent", "agent_id", "session", "session_id", "call_id", "principal_id", "owner_id",
  "panel_key", "panel_id", "return_panel", "scope", "showing", "context_revision",
]);

/** An explicit selection replaces declared business coordinates; it cannot replace the link or host identity. */
export function surfaceNavigationContext(navigation: WorkspaceNavigation, link: WorkspaceLink,
  current: Record<string, string>, values: unknown): Record<string, string> {
  if (!values || typeof values !== "object" || Array.isArray(values)) throw new Error("导航资料必须是对象。 ");
  const fixed = new Set(HOST_COORDINATES);
  if (link.panel_context) fixed.add(link.panel_context);
  for (const [key, source] of Object.entries(link.context ?? {})) if (HOST_COORDINATES.has(key)) fixed.add(source);
  const declared = new Set([...Object.keys(navigation.state_context), ...Object.values(link.context ?? {})]
    .filter(key => /^[A-Za-z_][A-Za-z0-9_]*$/.test(key) && !fixed.has(key)));
  const next = { ...current };
  for (const key of declared) delete next[key];
  for (const [key, value] of Object.entries(values)) {
    if (!declared.has(key)) throw new Error("当前界面没有声明这个导航坐标。 ");
    if (value === null || value === "") delete next[key];
    else if (typeof value === "string" && value.trim()) next[key] = value;
    else if (typeof value === "number" && Number.isFinite(value)) next[key] = String(value);
    else throw new Error("导航坐标必须是文字、有限数字或空值。 ");
  }
  return next;
}
